import { Component, OnInit, Input } from '@angular/core';

declare var $: any;

@Component({
  selector: 'modal-popup',
  templateUrl: './modal-popup.component.html',
  styleUrls: ['./modal-popup.component.css']
})
export class ModalPopupComponent implements OnInit {

  @Input() modalTitle = "";
  @Input() modalContent = "";

  ngOnInit() {

  }

  popUp() {
     $('#myModal').modal('show');
  }

}
